import React, { useEffect, useState } from 'react';
import { Box, CssBaseline, Grid, Button } from '@material-ui/core';
import { useStyles } from './styles';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getContent, getSpocDetails } from '../../actions';
import { DocumentsRequiredPopup }  from './DocumentsRequiredPopup';
import { HowItWorks } from './HowItWorks';
import { getAppSource, getUserType } from '../../helpers';
import playIcon from '../../assets/playIcon.png';
import CustomBreadcrum from '../Breadcrum';
import Cookies from 'js-cookie';

export const Lma = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [lmaFormUrl, setLmaFormUrl] = useState(null);
  const [lmaYoutubeVideo, setLmaYoutubeVideo] = useState(null);
  const [lmaPopupContent, setLmaPopupContent] = useState(null);
  const [openStatus, setOpenStatus] = useState(false);
  const [alertStatus, setAlertStatus] = useState(false);

  useEffect(() => {
    getContentData();
    if (props.accountNumber) {
    getSpocDetail(props)
    }
  }, [props])

  const getSpocDetail = async (props) => {
    const data = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSpocDetails(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      getLMAStatus(res?.responseData?.responseData.lmaStatus)
    } 
  }

  const getLMAStatus = (lmaStatus) => {
    if ((lmaStatus.toLowerCase() == "spoc") || (lmaStatus.toLowerCase() == 'lma not allowed')) {
      history.push('/FinancialHardship')
    } else if ((lmaStatus.toLowerCase() !== "in progress") && (lmaStatus.toLowerCase() !== "blank")) {
      history.push('/LmaStatus')
    } 
  }

  const getContentData = async () => {
    const res = await dispatch(getContent('PC032'));
    if (res) {
      res.map(content => {
        switch (content.contentKey.toUpperCase()) {
          case 'LMAFORMURL':
            setLmaFormUrl(content);
            return;
          case 'LMAYOUTUBEVIDEO':
            setLmaYoutubeVideo(content);
            return;
          case 'LMAPOPUP':
            setLmaPopupContent(content);
            return;
          default:
            break;
        }
      })
    }
  }

  const downloadForm = () => {
    var a = document.createElement('a');
    a.target="_blank"
    a.href = lmaFormUrl.contentValue
    a.click()
  }

  const routeToFinancialHardship = () => {
    history.push('/FinancialHardship')
  }

  const handleClose = () => {
    setOpenStatus(false);
  }

  const handleVideo = () => {
    setAlertStatus(true)
  }
 
  const handleAlertClose = () => {
    setAlertStatus(false)
  }

  return (
    <CssBaseline>
      <>
       <Box container="true" maxWidth='xl' className={classes.root}>      
        <Box className={classes.container}>
          <CustomBreadcrum backPage="Payments" backPageLink="/PaymentOption" activePage="Financial Hardship" />
          <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Loss Mitigation Application</h1>
          <Box className={classes.infoStrip}>
            <Grid container spacing={1} justifyContent="space-around" columns={{ xs: 12, sm: 12, md: 12 }} >
                <Grid item xs={12} sm={12} md={8} >
                  <p className={classes.procedureToFill}>Procedure to fill Loss Mitigation Application</p>
                </Grid>
            
                <Grid item xs={12} sm={12} md={4} >
                    <Button size="large" fullWidth onClick={() => handleVideo()}
                      variant='outlined' className={classes.play}>
                        <span style={{ paddingRight: '6px', marginTop: '4px' }}><img src={playIcon} /></span>See how it works
                    </Button>
                </Grid>
            </Grid> 
          <p className={classes.readInst}>Please read the instructions carefully before proceeding to next steps:</p>   
          <p className={classes.line}></p>
          <Box>
            <p className={classes.downloadForm}>Step 1: Fill Loss Mitigation form & Provide Hardship Details</p>
            <ul className={classes.instruction}>
              <li>Click the <span className={classes.downloadInst}>'Download Form'</span> button below to save the Loss Mitigation form to your system.</li>
              <Button className={classes.btn} variant="contained" color='primary' onClick={() => downloadForm()}>download form</Button>
              <li>Fill out the downloaded form.</li>
              {/* <li>Save the filled Loss Mitigation form to your system.</li> */}
            {/* </ul> */}
          {/* </Box>
          <Box> */}
            {/* <p className={classes.downloadForm}>Step 2. Hardship Details & Upload Loss Mitigation form</p> */}
            {/* <ul className={classes.instruction}> */}
              <li>Provide your Hardship Details.</li>
              <li>Use the <span className={classes.downloadInst}>‘Choose File’</span> button to locate the saved form and select it for upload after clicking on <span className={classes.downloadInst}>‘Proceed’</span> button below.</li>
            </ul>
          </Box>
          <Box>
            <p className={classes.downloadForm}>Step 2: Upload Supporting Documents</p>
            <ul className={classes.instruction}>
              <li>Scan your original documents that you think are applicable and keep the digital copies ready for filling out the loss mitigation application.</li>
              <li>For detailed instructions on the below documents, <span className={classes.linkStyle} onClick={() => setOpenStatus(true)}>click here</span>.</li>
            </ul>
          </Box>
          <Box className={classes.supportedDocContainer}>

            <Grid container justifyContent="center">
              <Grid item xs={12} sm={12} md={6} >
                <p className={classes.supportedDoc}>Loss Mitigation Documents:</p>
                    <ul className={classes.instruction}>
                    <li>Home Owner Association.</li>
                    <li>IRS Form 4506C</li>
                    <li>Last two (2) years Federal tax returns filed</li>
                    <li>Photo Identity Document</li>
                </ul>
                <p className={classes.supportedDoc}>Income Source Documents:</p>
                    <ul className={classes.instruction}>
                    <li>Wage Income / Recent Pay Stubs (If Salaried).</li>
                    <li>Self Employment</li>
                    <li>Other Incomes</li>
                    <li>Rental Income</li>
                    <li>Child Support and Alimony Income</li>
                </ul>
              </Grid>
            
              <Grid item xs={12} sm={12} md={6} >
                <p className={classes.supportedDoc}>Miscellaneous Documents:</p>
                <ul className={classes.instruction}>
                    <li>Personal Checking Bank Statements</li>
                    <li>Business Checking Bank Statement</li>
                    <li>Proof Of Occupancy (Utility Bill)</li>
                    <li>Current Property Tax Bill (If Escrowed)</li>
                    <li>Homeowner's Insurance (If Escrowed)</li>
                    <li>Change of Name</li>
                    <li>Divorce or Legal Separation</li>
                    <li>Recorded Quit Claim Deed (In case of Divorce / Legal Separation)</li>
                    <li>Death of a Borrower</li>
                </ul>    
             </Grid>
            </Grid>    
          </Box>

          <Box className={classes.footerSection}>
                <Grid container style={{ marginTop: '12px' }}>
                    <Grid item xs={6} md={6} className={classes.pr35}>
                        <Box className={classes.cancelBtnBox}>
                        <Button
                            className={classes.cancelBtn}
                            variant="outlined"
                            onClick={() => routeToFinancialHardship()} 
                        >BACK</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={6} md={6} className={classes.pl35}>
                        <Box className={classes.saveBtnBox}>
                            <Button
                            className={classes.saveBtn}
                            variant="contained"
                            onClick={() => history.push('/LmaDetails')}
                            color="primary">
                            PROCEED</Button> 
                        </Box>
                    </Grid>
                </Grid>
            </Box>

         </Box>
        </Box>
      </Box>
      {  openStatus && 
        <DocumentsRequiredPopup handleClose={handleClose} lmaPopupContent={lmaPopupContent}/>
       }
      <HowItWorks
        open={alertStatus}
        handleAlertClose={handleAlertClose}
      /> 
     </> 
    </CssBaseline>
  )
}

